/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLibraryImageAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6 2h16v11h-2V4H8v2h10v7h-2V8H4v12h9v2H2V6h4z" />
        <path d="M13 16.2V19H5l2.857-6L10 16.75l1.786-2.25zm1-4.7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4 3.5v3h-3v2h3v3h2v-3h3v-2h-3v-3z" />
      </g>
    </g>
  </Icon>
);
export { SvgLibraryImageAdd as LibraryImageAdd };
